import React, { useState } from "react";
import { toast } from "sonner";
import { X, Plus, Trash2 } from "lucide-react";
import { api } from "../../lib/api";

export default function DocumentCategoriesModal({ categories, onClose, onChange }) {
    const [newName, setNewName] = useState("");
    const [creating, setCreating] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [editName, setEditName] = useState("");

    const create = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (creating) return;
        const name = newName.trim();
        if (name.length < 2) { toast.error("Nome troppo corto"); return; }
        setCreating(true);
        try {
            await api.post("/internal/document-categories", { name });
            toast.success("Categoria creata");
            setNewName("");
            onChange();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Errore");
        } finally { setCreating(false); }
    };

    const saveRename = async (cat) => {
        const name = editName.trim();
        if (name.length < 2 || name === cat.name) { setEditingId(null); return; }
        try {
            await api.patch(`/internal/document-categories/${cat.id}`, { name });
            toast.success("Categoria rinominata");
            setEditingId(null);
            onChange();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Errore");
        }
    };

    const toggleActive = async (cat) => {
        try {
            await api.patch(`/internal/document-categories/${cat.id}`, { active: !cat.active });
            onChange();
        } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    };

    const remove = async (cat) => {
        if (!window.confirm(`Eliminare la categoria "${cat.name}"?`)) return;
        try {
            await api.delete(`/internal/document-categories/${cat.id}`);
            toast.success("Categoria eliminata");
            onChange();
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Errore");
        }
    };

    return (
        <div className="lt-modal-backdrop" onClick={onClose}>
            <div className="lt-modal" onClick={(e) => e.stopPropagation()} data-testid="doc-cats-modal" style={{ maxWidth: 560 }}>
                <div className="lt-modal__head">
                    <h2 className="lt-modal__title">Gestisci categorie documento</h2>
                    <button className="lt-icon-btn" onClick={onClose} aria-label="Chiudi"><X size={16} /></button>
                </div>
                <div style={{ padding: 16 }}>
                    <form onSubmit={create} method="post" action="#" noValidate style={{ display: "flex", gap: 8, marginBottom: 20 }}>
                        <input
                            className="lt-input"
                            style={{ flex: 1 }}
                            placeholder="Nuova categoria…"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            data-testid="doc-cat-new-input"
                            minLength={2}
                            maxLength={80}
                        />
                        <button type="submit" className="lt-btn-primary" disabled={creating} onClick={create} data-testid="doc-cat-create-btn">
                            <Plus size={14} /> Crea
                        </button>
                    </form>
                    <div data-testid="doc-cat-list">
                        {(categories || []).length === 0 && (
                            <div style={{ color: "#8A8F88", padding: 16, textAlign: "center" }}>
                                Nessuna categoria ancora creata.
                            </div>
                        )}
                        {(categories || []).map(cat => (
                            <div key={cat.id} data-testid={`doc-cat-row-${cat.id}`}
                                style={{
                                    display: "flex", alignItems: "center", gap: 8,
                                    padding: "10px 0", borderBottom: "1px solid #EFEFEC",
                                }}>
                                {editingId === cat.id ? (
                                    <input
                                        className="lt-input"
                                        style={{ flex: 1 }}
                                        value={editName}
                                        onChange={(e) => setEditName(e.target.value)}
                                        onBlur={() => saveRename(cat)}
                                        onKeyDown={(e) => { if (e.key === "Enter") saveRename(cat); if (e.key === "Escape") setEditingId(null); }}
                                        autoFocus
                                        data-testid={`doc-cat-edit-input-${cat.id}`}
                                    />
                                ) : (
                                    <button
                                        type="button"
                                        onClick={() => { setEditingId(cat.id); setEditName(cat.name); }}
                                        style={{ flex: 1, textAlign: "left", background: "transparent", border: "none", cursor: "pointer", padding: 4, color: cat.active ? "#181B20" : "#8A8F88" }}
                                        data-testid={`doc-cat-name-${cat.id}`}
                                    >
                                        {cat.name}
                                        {cat.in_use && <span style={{ fontSize: 11, color: "#8A8F88", marginLeft: 8 }}>({cat.documents_count} doc)</span>}
                                        {!cat.active && <span style={{ fontSize: 11, color: "#8A8F88", marginLeft: 8 }}>· disattivata</span>}
                                    </button>
                                )}
                                <button type="button" className="lt-btn-secondary" style={{ fontSize: 12, padding: "4px 10px" }} onClick={() => toggleActive(cat)} data-testid={`doc-cat-toggle-${cat.id}`}>
                                    {cat.active ? "Disattiva" : "Riattiva"}
                                </button>
                                <button type="button" className="lt-icon-btn" onClick={() => remove(cat)} aria-label="Elimina" data-testid={`doc-cat-delete-${cat.id}`}>
                                    <Trash2 size={14} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
